import type { Feature } from '@luna/gatekeeper';

export const changePinDelivery: Feature = {
    enabled: true,
    _description: 'Displays the refactored pin change delivery focus page',
};
